import {NgModule} from '@angular/core';
import {P2ButtonModule} from './button/button';

const coreModules = [
  P2ButtonModule
];

@NgModule({
  imports: coreModules,
  exports: coreModules,
  providers: [],
})
export class P2ComponentsModule { }
